<template>
  <div class="modal-header rounded-0">
    <slot>
      <h5 v-if="title" class="modal-title">
        {{ title }}
      </h5>

      <button
        v-if="dismissable"
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </slot>
  </div>
</template>

<script setup lang="ts">
type Props = {
  title?: string;
  dismissable?: boolean;
};
defineProps<Props>();
</script>
